var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoices01 = function SvgInvoices01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "invoices-01_svg2__a",
    x1: 21.44,
    x2: 172.32,
    y1: 185.58,
    y2: 34.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__b",
    x1: 27.12,
    x2: 177.99,
    y1: 191.26,
    y2: 40.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__c",
    x1: 45.32,
    x2: 196.2,
    y1: 209.46,
    y2: 58.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__d",
    x1: 45.9,
    x2: 196.78,
    y1: 210.04,
    y2: 59.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__e",
    x1: 64.11,
    x2: 214.98,
    y1: 228.25,
    y2: 77.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__f",
    x1: 73.62,
    x2: 224.49,
    y1: 237.76,
    y2: 86.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__g",
    x1: 17.32,
    x2: 168.19,
    y1: 181.46,
    y2: 30.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices-01_svg2__a",
    id: "invoices-01_svg2__h",
    x1: -25.8,
    x2: 125.08,
    y1: 138.35,
    y2: -12.53
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M169.97 61.1H76.5c-5.43 0-9.84 4.43-9.84 9.87v25.71c0 5.41 4.4 9.82 9.82 9.82h93.5c5.43 0 9.84-4.4 9.84-9.82V70.95c0-5.43-4.42-9.84-9.84-9.84Zm3.77 35.57c0 2.07-1.7 3.75-3.78 3.75h-93.5c-2.07 0-3.75-1.68-3.75-3.75V70.96c0-2.1 1.7-3.8 3.78-3.8h93.47c2.08 0 3.78 1.69 3.78 3.78z",
    style: {
      fill: "url(#invoices-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.37 147.39h14.68c4.08 0 7.39-3.31 7.39-7.39v-14.68c0-4.08-3.32-7.39-7.39-7.39H78.37c-4.08 0-7.39 3.32-7.39 7.39V140c0 4.07 3.32 7.39 7.39 7.39m-1.33-22.07c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33V140c0 .73-.6 1.33-1.33 1.33H78.37c-.73 0-1.33-.6-1.33-1.33z",
    style: {
      fill: "url(#invoices-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74 153.66H79.06c-4.08 0-7.39 3.31-7.39 7.39v14.68c0 4.08 3.31 7.39 7.39 7.39h14.68c4.08 0 7.39-3.32 7.39-7.39v-14.68c0-4.07-3.31-7.39-7.39-7.39m1.33 22.07c0 .73-.6 1.33-1.33 1.33H79.06c-.73 0-1.33-.6-1.33-1.33v-14.68c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33z",
    style: {
      fill: "url(#invoices-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.94 147.39h14.69c4.08 0 7.39-3.31 7.39-7.39v-14.68c0-4.08-3.31-7.39-7.39-7.39h-14.69c-4.08 0-7.39 3.32-7.39 7.39V140c0 4.07 3.32 7.39 7.39 7.39m-1.33-22.07c0-.73.6-1.33 1.33-1.33h14.69c.73 0 1.33.6 1.33 1.33V140c0 .73-.6 1.33-1.33 1.33h-14.69c-.73 0-1.33-.6-1.33-1.33z",
    style: {
      fill: "url(#invoices-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.31 153.66h-14.68c-4.08 0-7.39 3.31-7.39 7.39v14.68c0 4.08 3.32 7.39 7.39 7.39h14.68c4.08 0 7.39-3.32 7.39-7.39v-14.68c0-4.07-3.32-7.39-7.39-7.39m1.34 22.07c0 .73-.6 1.33-1.33 1.33h-14.68c-.73 0-1.33-.6-1.33-1.33v-14.68c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33z",
    style: {
      fill: "url(#invoices-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2 117.92h-14.68c-4.08 0-7.39 3.31-7.39 7.39v50.41c0 4.08 3.31 7.39 7.39 7.39h14.68c4.08 0 7.39-3.32 7.39-7.39v-50.41c0-4.08-3.32-7.39-7.39-7.39m1.33 57.8c0 .73-.6 1.33-1.33 1.33h-14.68c-.73 0-1.33-.6-1.33-1.33v-50.41c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33z",
    style: {
      fill: "url(#invoices-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22 48.76h-19.57V12.74C155.65 5.71 149.93 0 142.9 0H20.61C13.6 0 7.89 5.71 7.89 12.74v174.53c0 7.01 5.7 12.72 12.71 12.72h50.33c.09 0 .17.01.26.01h104.03c9.32 0 16.89-7.59 16.89-16.92V65.68c0-9.33-7.58-16.92-16.89-16.92M32.69 75.81h21.62v14.93H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h21.62v14.93H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h21.62v14.93H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h21.62v14.93H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h21.62v23.3c0 .97.1 1.92.26 2.85.02.09.02.18.04.26.17.89.41 1.76.71 2.6.04.1.07.21.11.31.32.83.69 1.64 1.14 2.4.04.07.08.13.12.2.47.79.98 1.54 1.57 2.24H20.61c-3.67 0-6.65-2.98-6.65-6.65V12.74c0-3.68 2.98-6.68 6.65-6.68h122.3c3.68 0 6.68 3 6.68 6.68v36.02H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h25.58a16.83 16.83 0 0 0-3.96 10.86v4.07H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03m142.54 118.13H71.19c-5.97 0-10.83-4.87-10.83-10.86V65.7c0-5.99 4.86-10.86 10.83-10.86h104.03c5.97 0 10.83 4.87 10.83 10.86v117.4h.01c0 5.98-4.86 10.85-10.83 10.85Z",
    style: {
      fill: "url(#invoices-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.69 33.82h98.14c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03H32.69c-1.67 0-3.03 1.36-3.03 3.03s1.35 3.03 3.03 3.03",
    style: {
      fill: "url(#invoices-01_svg2__h)"
    }
  }));
};
export default SvgInvoices01;